<template>
  <div>
    <div class="table-wapper" ref="toolbarTable">
      <table>
        <thead>
          <tr class="tittle-table">
            <th
              v-for="col in columns"
              :key="col.key"
              :class="col.headerClass"
            >
              {{ col.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!data || data.length === 0">
            <td :colspan="columns.length" class="text-center empty-row">
              {{ emptyText }}
            </td>
          </tr>
          <tr
            v-for="(row, rowIndex) in data"
            :key="rowIndex"
            :class="rowClass(row, rowIndex)"
            @click="$emit('row-click', row, rowIndex)"
          >
            <td
              v-for="col in columns"
              :key="col.key"
              :class="col.cellClass"
            >
              <slot
                v-if="col.slot"
                :name="col.slot"
                :row="row"
                :value="getCellValue(row, col)"
                :index="rowIndex"
              />
              <span v-else>{{ getCellValue(row, col) }}</span>
            </td>
          </tr>
        </tbody>
        <tfoot v-if="footer && footer.length > 0">
          <tr
            v-for="(footerRow, footerIndex) in footer"
            :key="footerIndex"
            class="footer-table"
          >
            <td
              v-for="col in columns"
              :key="col.key"
              :class="col.footerClass || col.cellClass"
            >
              <slot
                v-if="col.footerSlot"
                :name="col.footerSlot"
                :row="footerRow"
                :value="getFooterValue(footerRow, col)"
                :index="footerIndex"
              />
              <span v-else>{{ getFooterValue(footerRow, col) }}</span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n'

export default {
  name: 'UiTableBasic',

  props: {
    /**
     * [{ key: 'name', label: 'Họ tên', headerClass: '', cellClass: 'text-center', slot: 'name' }]
     */
    columns: {
      type: Array,
      required: true,
      default: () => []
    },

    data: {
      type: Array,
      default: () => []
    },

    emptyText: {
      type: String,
      default: i18n.t('no_data')
    },

    /**
     * [{ name: 'Grand total', total: 1000, ... }]
     */
    footer: {
      type: Array,
      default: () => []
    },

    /**
     *  Function: (row, index) => string | object | array
     */
    rowClassName: {
      type: [String, Function],
      default: ''
    }
  },

  methods: {
    /**
     * Get value cell, support nested: 'user.name'
     */
    getCellValue(row, col) {
      if (col.formatter && typeof col.formatter === 'function') {
        return col.formatter(row[col.key], row)
      }
      if (!col.key) return ''
      return col.key.split('.').reduce((obj, k) => (obj != null ? obj[k] : ''), row)
    },

    getFooterValue(row, col) {
      if (col.footerFormatter && typeof col.footerFormatter === 'function') {
        return col.footerFormatter(row[col.key], row)
      }
      return this.getCellValue(row, col)
    },

    rowClass(row, index) {
      if (typeof this.rowClassName === 'function') {
        return this.rowClassName(row, index)
      }
      return this.rowClassName || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wapper {
  overflow-x: auto;
  table {
    width: 100%;
    color: #333;
    border: 0 solid #e4e3e4;
    border-collapse: collapse;
    border-spacing: 0;
    background-color: #fff;
    border-width: 1px 0 0 1px;
    border-radius: 7px;
    letter-spacing: 0;
    font-size: 15px;
    font-weight: 400;
    td,
    tr,
    th {
      border: 1px solid #e4e3e4;
      padding: 8px;
      vertical-align: middle;
    }
    .tittle-table {
      color: #fff;
      background-color: #92a1ab;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;
      th {
        font-size: 16px;
        text-transform: capitalize;
        border-bottom-width: 1px;
        padding-top: 2px;
        text-align: center;
        padding: 5px;
        border: 1px solid #e4e3e4;
        vertical-align: middle;
      }
    }
    .footer-table {
      color: #fff;
      background-color: #92a1ab;
      border-bottom-left-radius: 7px;
      border-bottom-right-radius: 7px;
      position: sticky;
      bottom: 0;
      td {
        font-size: 15px;
        font-weight: 600;
        padding: 5px 8px;
        border: 1px solid #e4e3e4;
        vertical-align: middle;
      }
    }
    .empty-row {
      padding: 20px;
      color: #999;
      font-style: italic;
    }
    .text-center {
      text-align: center;
    }
    .text-right {
      text-align: right;
    }
    .min_width {
      min-width: 150px;
    }
    .report_date {
      min-width: 140px;
    }
    .report_name {
      min-width: 230px;
    }
    .report_total {
      width: 100px;
    }
    .report_note {
      width: 150px;
    }
    .report_shift {
      min-width: 100px;
    }
    .pre-line {
      white-space: pre-line;
    }
  }
}
</style>
